module.exports = __webpack_public_path__ + "tick-cross.png?9e4be8f33f9e5789fd7dd5acd6426492";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tick-cross.png
// module id = 8
// module chunks = 0